import { createGlobalStyle } from 'styled-components';
import { StyleConstants } from './StyleConstants';
/* istanbul ignore next */
export const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
    line-height: 1.5;
    overflow: visible;
  }

  body {
    font-family: ff-basic-gothic-pro, sans-serif;
    background-color: #f5f5f5;
    font-size: 18px;
    overflow: visible;
  }

  body.fontLoaded {
    font-family: ff-basic-gothic-pro, sans-serif;
    font-size: 18px;
    overflow: visible;
  }

  input[type="radio"]:checked, input[type="checkbox"]:checked {
    background-color: #4E0075;
  }

  p,
  label {
    line-height: 1.5em;
  }

  input, select, button {
    font-family: inherit;
    font-size: inherit;
  }

  .icon {
    width: 1.5rem;
    height: 1.5rem;
  }
`;
